import * as React from 'react'
import type { SVGProps } from 'react'
const SvgArrowUpRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.63786 4.72053L11.3192 4.72045M11.3192 4.72045L11.3192 10.321M11.3192 4.72045L4.71953 11.3201"
      stroke="#45465B"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
export default SvgArrowUpRight
